import "./conditions.scss";
import "./js/modernizr.js";
import { Menu } from "./js/navigation.js";
import "./js/lang.js";
let menu = new Menu($(".menu"), $(".navigation__btn"));